import {
  SIGNUP_SENT,
  SIGNUP_SUCCEEDED,
  SIGNUP_FAILED,
  LOGIN_SENT,
  LOGIN_SUCCEEDED,
  LOGIN_FAILED,
  LOGOUT,
  CHANGE_PASSWORD_SENT,
  CHANGE_PASSWORD_SUCCEEDED,
  CHANGE_PASSWORD_FAILED,
  RESET_PASSWORD_SENT,
  RESET_PASSWORD_SUCCEEDED,
  RESET_PASSWORD_FAILED,
  SEND_RESET_PASSWORD_LINK_REQUESTED,
  SEND_RESET_PASSWORD_LINK_SUCCEEDED,
  SEND_RESET_PASSWORD_LINK_FAILED,
  UPDATE_AFTER_SIGNUP_TO_FALSE,
} from '../../actions/auth';

import {
  UPDATE_STUDENT_PROFILE_SENT,
  UPDATE_STUDENT_PROFILE_SUCCEEDED,
  UPDATE_STUDENT_PROFILE_FAILED,
  UPDATE_TUTOR_PROFILE_SENT,
  UPDATE_TUTOR_PROFILE_SUCCEEDED,
  UPDATE_TUTOR_PROFILE_FAILED,
  FETCH_CURRENT_USER_SENT,
  FETCH_CURRENT_USER_SUCCEEDED,
  FETCH_CURRENT_USER_FAILED,
  UPLOAD_AVATAR_SENT,
  UPLOAD_AVATAR_SUCCEEDED,
  UPLOAD_AVATAR_FAILED,
  DELETE_AVATAR_SENT,
  DELETE_AVATAR_SUCCEEDED,
  DELETE_AVATAR_FAILED,
  SET_SKYPE_ID_SENT,
  SET_SKYPE_ID_SUCCEEDED,
  SET_SKYPE_ID_FAILED,
  SET_TEAMS_CONTACT_EMAIL_SENT,
  SET_TEAMS_CONTACT_EMAIL_SUCCEEDED,
  SET_TEAMS_CONTACT_EMAIL_FAILED,
  DEACTIVATE_USER_SENT,
  DEACTIVATE_USER_FAILED,
  SET_SKYPE_MODAL_SHOWN,
  SET_TEAMS_MODAL_SHOWN,
} from '../../actions/currentUser';

import {
  BOOK_SUCCEEDED,
  CANCEL_BOOKING_SUCCEEDED,
} from '../../actions/booking';

import {
  SUBSCRIBE_WITH_STRIPE_SUCCEEDED,
  SUSPEND_SUBSCRIPTION_SUCCEEDED,
  REACTIVATE_SUBSCRIPTION_SUCCEEDED,
  TRANSFER_SUBSCRIPTION_SUCCEEDED,
  RENEW_SUBSCRIPTION_SUCCEEDED,
} from '../../actions/payment';

import { PAY_INVOICE_SUCCEEDED } from '../../actions/billing-history';

let authToken = null;
let user = null;
if (typeof localStorage !== 'undefined') {
  authToken = localStorage.getItem('authToken') || null;
}

const initialState = {
  loading: false,
  loaded: false,
  resetPasswordLinkSent: false,
  waiting: false,
  mutatingAvatar: false,
  justSignedUp: false,
  skypeWarningShown: true,
  teamsWarningShown: true,
  authToken,
  user,
};

export default function authReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case SIGNUP_SENT:
    case LOGIN_SENT:
    case CHANGE_PASSWORD_SENT:
    case RESET_PASSWORD_SENT:
    case SEND_RESET_PASSWORD_LINK_REQUESTED:
    case UPDATE_STUDENT_PROFILE_SENT:
    case UPDATE_TUTOR_PROFILE_SENT:
    case DEACTIVATE_USER_SENT:
    case SET_SKYPE_ID_SENT:
    case SET_TEAMS_CONTACT_EMAIL_SENT:
      return {
        ...state,
        waiting: true,
      };
    case SIGNUP_SUCCEEDED:
      return {
        ...state,
        authToken: payload.authToken,
        user: payload.user,
        waiting: false,
        justSignedUp: true,
      };
    case LOGIN_SUCCEEDED:
    case RESET_PASSWORD_SUCCEEDED:
    case CHANGE_PASSWORD_SUCCEEDED:
    case UPDATE_STUDENT_PROFILE_SUCCEEDED:
    case UPDATE_TUTOR_PROFILE_SUCCEEDED:
    case UPLOAD_AVATAR_SUCCEEDED:
    case DELETE_AVATAR_SUCCEEDED:
    case BOOK_SUCCEEDED:
    case CANCEL_BOOKING_SUCCEEDED:
    case SET_SKYPE_ID_SUCCEEDED:
    case SET_TEAMS_CONTACT_EMAIL_SUCCEEDED:
    case PAY_INVOICE_SUCCEEDED:
      return {
        ...state,
        authToken: payload.authToken,
        user: payload.user,
        waiting: false,
        mutatingAvatar: false,
        justSignedUp: false,
      };
    case SIGNUP_FAILED:
    case LOGIN_FAILED:
    case RESET_PASSWORD_FAILED:
    case SEND_RESET_PASSWORD_LINK_FAILED:
    case CHANGE_PASSWORD_FAILED:
    case UPDATE_STUDENT_PROFILE_FAILED:
    case UPDATE_TUTOR_PROFILE_FAILED:
    case DEACTIVATE_USER_FAILED:
    case SET_SKYPE_ID_FAILED:
    case SET_TEAMS_CONTACT_EMAIL_FAILED:
      return {
        ...state,
        waiting: false,
      };
    case LOGOUT:
      return initialState;
    case FETCH_CURRENT_USER_SENT:
      return {
        ...state,
        loading: true,
      };
    case FETCH_CURRENT_USER_SUCCEEDED:
    case SUBSCRIBE_WITH_STRIPE_SUCCEEDED:
    case SUSPEND_SUBSCRIPTION_SUCCEEDED:
    case REACTIVATE_SUBSCRIPTION_SUCCEEDED:
    case TRANSFER_SUBSCRIPTION_SUCCEEDED:
    case RENEW_SUBSCRIPTION_SUCCEEDED:
      return {
        ...state,
        user: payload.user,
        loading: false,
        loaded: true,
      };
    case FETCH_CURRENT_USER_FAILED:
      return {
        ...state,
        loading: false,
        loaded: true,
      };
    case SEND_RESET_PASSWORD_LINK_SUCCEEDED:
      return {
        ...state,
        waiting: false,
        resetPasswordLinkSent: true,
      };
    case UPDATE_AFTER_SIGNUP_TO_FALSE:
      return {
        ...state,
        justSignedUp: false,
      };
    case UPLOAD_AVATAR_SENT:
    case DELETE_AVATAR_SENT:
      return {
        ...state,
        mutatingAvatar: true,
      };
    case UPLOAD_AVATAR_FAILED:
    case DELETE_AVATAR_FAILED:
      return {
        ...state,
        mutatingAvatar: false,
      };
    case SET_SKYPE_MODAL_SHOWN:
      return {
        ...state,
        justSignedUp: false,
        skypeWarningShown: true,
      };
    case SET_TEAMS_MODAL_SHOWN:
      return {
        ...state,
        justSignedUp: false,
        teamsWarningShown: true,
      };
    default:
      return state;
  }
}
